import l from "./ghl-ui.es1378.js";
import f from "./ghl-ui.es750.js";
function d(n, e) {
  e = l(e, n);
  for (var r = 0, i = e.length; n != null && r < i; )
    n = n[f(e[r++])];
  return r && r == i ? n : void 0;
}
export {
  d as default
};
